import { addressFuncs } from '@fv/client-core'

import { AdminFormGroup } from '@/components/shared/AdminFormGroup'
import { AdminNavLink } from '@/components/shared/AdminLink'
import { AdminLoading } from '@/components/shared/AdminLoading'
import { AdminTooltip } from '@/components/shared/AdminTooltip'
import { useEntityPreview } from '@/features/preview/useEntityPreview'
import { AccountLink } from '@/features/reports/components/AccountLink'
import { CarrierLink } from '@/features/reports/components/CarrierLink'

const LOAD_PREVIEW_TOOLTIP_DELAY = 500

type Props = {
  loadId: string
}

export const LoadLink = ({ loadId }: Props) => {
  return <AdminNavLink to={`/loads/${loadId}`}>{loadId}</AdminNavLink>
}

export const ComparableLoadLink = ({ loadId }: Props) => {
  return (
    <AdminTooltip
      delay={LOAD_PREVIEW_TOOLTIP_DELAY}
      label={<LoadPreviewContent loadId={loadId} />}
    >
      <span>
        <LoadLink loadId={loadId} />
      </span>
    </AdminTooltip>
  )
}

const LoadPreviewContent = ({ loadId }: Props) => {
  const { data, isLoading } = useEntityPreview('load', loadId)

  if (isLoading) {
    return <AdminLoading />
  }
  return (
    <div className="text-sm w-96">
      <div className="flex flex-col gap-2">
        <AdminFormGroup label="Lane">
          {data ? (
            <div>
              {addressFuncs.cityStateZip(data.origin)} →{' '}
              {addressFuncs.cityStateZip(data.destination)}
            </div>
          ) : null}
        </AdminFormGroup>
        <div className="grid grid-cols-2 gap-2">
          <AdminFormGroup label="Account">
            <AccountLink _id={data?.accountId} />
          </AdminFormGroup>
          <AdminFormGroup label="Carrier">
            {data?.carrierId ? <CarrierLink _id={data.carrierId} /> : '—'}
          </AdminFormGroup>
        </div>
      </div>
    </div>
  )
}
